import { RATINGS_REVERSED_LIST } from "@goodfill/domain-properties";
import { PricedBond } from "../PricedBond";

// If a bond is not rated by one agency, a rating of 2 notches below
// the other agency is assumed for filter and sorting purposes only.
const OFFSET_FOR_MISSING_RATING = 2;

export function getBondRatingIndicesWithOffsetForMissingRating(bond: Pick<PricedBond, "ratings" | "bondIdCusip">) {
  const moodysIndex = bond.ratings.moodys !== null ? RATINGS_REVERSED_LIST.moodys.indexOf(bond.ratings.moodys) : -1;
  const spIndex = bond.ratings.sp !== null ? RATINGS_REVERSED_LIST.sAndP.indexOf(bond.ratings.sp) : -1;

  const normalizedMoodysIndex = moodysIndex === -1 ? Math.max(spIndex - OFFSET_FOR_MISSING_RATING, 0) : moodysIndex;
  const normalizedSpIndex = spIndex === -1 ? Math.max(moodysIndex - 2, 0) : spIndex;

  return { moodysIndex: normalizedMoodysIndex, spIndex: normalizedSpIndex };
}
